import RightTimeApi from "@/API";

/** Merge list + context into the same shape as the legacy monolith GET. */
export async function fetchCompanyJobsTabMerged(companyId: number | string) {
  const [listResp, contextResp] = await Promise.all([
    RightTimeApi.getAsync(`/CompanyJobsTab/${companyId}/list`),
    RightTimeApi.getAsync(`/CompanyJobsTab/${companyId}/context`),
  ]);

  if (!listResp?.ok || !listResp.jsonData) {
    return { ok: false as const, jsonData: null, listResp, contextResp };
  }

  const merged = { ...listResp.jsonData };
  if (contextResp?.ok && contextResp.jsonData) {
    Object.assign(merged, contextResp.jsonData);
  }

  return {
    ok: true as const,
    jsonData: merged,
    listResp,
    contextResp,
  };
}
